// IdentificationStatusInfo.jsx
import React from "react";
import { Tooltip, Modal, Typography, Button, Space, List } from "antd";
import { ExclamationCircleOutlined, BulbOutlined } from "@ant-design/icons";
import { IdentificationStatusTag } from "./IdentityStatusTag";
import { identityStatusConfig } from "../../../helper";
// MODIFIED: Import the new centralized config

const { Title, Paragraph, Text } = Typography;

export const IdentificationStatusInfo = ({ status, extraBelow }) => {
  const [open, setOpen] = React.useState(false);
  // MODIFIED: Use the new config. Fallback to "Manual Review".
  const config =
    identityStatusConfig[status] || identityStatusConfig["Manual Review"];

  return (
    <>
      <Tooltip title={config.short} placement="top">
        <span
          onClick={() => setOpen(true)}
          onKeyDown={(e) =>
            (e.key === "Enter" || e.key === " ") && setOpen(true)
          }
          role="button"
          tabIndex={0}
          style={{ cursor: "pointer" }}
          aria-label={`${status}. Click for details.`}
        >
          <IdentificationStatusTag status={status} />
        </span>
      </Tooltip>

      {extraBelow ? <div style={{ marginTop: 6 }}>{extraBelow}</div> : null}

      <Modal
        title={null}
        open={open}
        onCancel={() => setOpen(false)}
        centered
        destroyOnClose
        maskClosable
        footer={
          <div style={{ textAlign: "right" }}>
            <Button type="primary" onClick={() => setOpen(false)}>
              Close
            </Button>
          </div>
        }
        width={520}
        styles={{
          body: { padding: "24px" },
          footer: {
            borderTop: "1px solid #f0f0f0",
            padding: "12px 24px",
            margin: 0,
          },
        }}
      >
        <Space direction="vertical" size={20} style={{ width: "100%" }}>
          {/* Section 1: Main Header */}
          <div>
            <Space align="center" size="middle">
              {/* DYNAMIC ICON AND COLOR: Use the icon and color from the config */}
              {React.cloneElement(config.ui.icon, {
                style: { fontSize: 24, color: config.ui.color },
              })}
              <Title level={4} style={{ margin: 0 }}>
                {status}
              </Title>
            </Space>
            <Paragraph type="secondary" style={{ margin: "4px 0 0 0" }}>
              {config.short}
            </Paragraph>
          </div>

          {/* Card-like container for the details */}
          <div
            style={{
              backgroundColor: "#fafafa",
              border: "1px solid #f0f0f0",
              borderRadius: 8,
              padding: "16px 20px",
            }}
          >
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              {/* Section 2: Why this status */}
              <Space direction="vertical" size={4} style={{ width: "100%" }}>
                <Space align="center">
                  <ExclamationCircleOutlined style={{ color: "#d97706" }} />
                  <Text strong>Why this status</Text>
                </Space>
                <List
                  dataSource={config.details}
                  renderItem={(item) => (
                    <List.Item style={{ paddingLeft: 24, border: "none" }}>
                      <Text
                        type="secondary"
                        style={{
                          display: "list-item",
                          listStyleType: "disc",
                          listStylePosition: "inside",
                          fontSize: 15,
                          lineHeight: "1.5",
                          color: "#393b4a",
                        }}
                      >
                        {item}
                      </Text>
                    </List.Item>
                  )}
                  split={false}
                  size="small"
                />
              </Space>

              {/* Section 3: Recommended next steps */}
              <Space direction="vertical" size={4} style={{ width: "100%" }}>
                <Space align="center">
                  <BulbOutlined style={{ color: "#2563eb" }} />
                  <Text strong>Recommended next steps</Text>
                </Space>
                <List
                  dataSource={config.actions}
                  renderItem={(item) => (
                    <List.Item style={{ paddingLeft: 24, border: "none" }}>
                      <Text
                        type="secondary"
                        style={{
                          display: "list-item",
                          listStyleType: "disc",
                          listStylePosition: "inside",
                          fontSize: 15,
                          lineHeight: "1.5",
                          color: "#393b4a",
                        }}
                      >
                        {item}
                      </Text>
                    </List.Item>
                  )}
                  split={false}
                  size="small"
                />
              </Space>
            </Space>
          </div>
        </Space>
      </Modal>
    </>
  );
};
